import { base64UrlEncode } from '@luna/utils';

import { luxCrossApplicationTrackingProperties } from './trackers/LuxTrackerService';
import { getPostHogCrossApplicationTrackingProperties } from './trackers/PostHogTrackerService';

const CROSS_APPLICATION_TRACKING_URL_PARAM_NAME = 'analytics';

function buildCrossApplicationTrackingUrlParam(
    scopedTrackingParams: Record<string, unknown>,
): string {
    const globalTrackingProperties = {
        ...getPostHogCrossApplicationTrackingProperties(),
        ...luxCrossApplicationTrackingProperties(),
    };

    const analyticsObject = {
        global: globalTrackingProperties,
        scoped: scopedTrackingParams,
    };

    return base64UrlEncode(JSON.stringify(analyticsObject));
}

export function addCrossApplicationTrackingParamToUrl(
    url: URL,
    trackingParams: Record<string, unknown> = {},
): void {
    url.searchParams.set(
        CROSS_APPLICATION_TRACKING_URL_PARAM_NAME,
        buildCrossApplicationTrackingUrlParam(trackingParams),
    );
}
